// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1ynlB","title":"Info_title__2L2oX","links":"Info_links__28fVe","link":"Info_link__3fZ1i","logo":"Info_logo__2xjfM"};